import { PromoServiceI } from '../../../index.d'
import { Api } from '../../api'

export class PromoService implements PromoServiceI {
  async checkPromocode(code: string): Promise<unknown> {
    const { data } = await Api.get(`/api/promo_codes/invite/${code}`)
    return data
  }
}
